import {
  CALCULATE_TDS_RATE_DATA,
  DOWNLOAD_PREPARE_DATA_API,
  FILE_UPLOAD_SUMMARY_API,
  GET_NEGATIVE_ENTERIES_DATA,
  GET_TRANSACTIONAL_DATA_API,
  INCLUDE_EXCLUDE_DATA_API,
  REPROCESS_VALIDATION_API,
  TRANSACTIONAL_DATA_SUM_API,
} from '../endpoints/apiEndpoints'

import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const getTransactionalData = async (payload, screenName) => {
  const url = urlBuilder(GET_TRANSACTIONAL_DATA_API, { screenName })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const includeExcludeActionUpdate = async (payload, action) => {
  const url = urlBuilder(INCLUDE_EXCLUDE_DATA_API, { action })
  const requestHeader = buildRequestHeader('PUT', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getFileSummary = async (tan, periodFilters) => {
  const url = urlBuilder(FILE_UPLOAD_SUMMARY_API)
  const payload = { tans: tan ? tan.split(',') : [], periodFilters }
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadPrepareDetailsData = async (payload, screenName, prepareDownloadType) => {
  const url = urlBuilder(DOWNLOAD_PREPARE_DATA_API, { screenName, prepareDownloadType })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}


export const calculateTDSRate = async (tan, periodFilters, screenName) => {
  const url = urlBuilder(
    CALCULATE_TDS_RATE_DATA,
  )
  const payload = { tans: tan ? tan.split(',') : [], periodFilters, uploadCategory: screenName }

  const requestHeader = buildRequestHeader('POST',payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getNegativeEnteires = async (payload) => {
  const url = urlBuilder(GET_NEGATIVE_ENTERIES_DATA)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getTotalSum = async (payload, screenName, isCompute = 'false') => {
  const url = urlBuilder(TRANSACTIONAL_DATA_SUM_API, { screenName, isCompute })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const reprocessValidation = async (payload, screenName) => {
  const url = urlBuilder(REPROCESS_VALIDATION_API, { screenName })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}
